import * as zod from 'zod';

export const FTPServerCommand = zod.object({
  kind: zod.literal('FTPServerCommand'),
  command: zod.union([
    zod.object({
      command: zod.literal('listFiles'),
      remotePath: zod.string().optional().default(''),
    }),
    zod.object({
      command: zod.literal('uploadFile'),
      localPath: zod.string(),
      remotePath: zod.string(),
    }),
    zod.object({
      command: zod.literal('downloadFile'),
      remotePath: zod.string(),
      localPath: zod.string(),
    }),
    zod.object({
      command: zod.literal('deleteFile'),
      remotePath: zod.string(),
    }),
    zod.object({
      command: zod.literal('createDirectory'),
      remotePath: zod.string(),
    }),
    zod.object({
      command: zod.literal('deleteDirectory'),
      remotePath: zod.string(),
    }),
    zod.object({
      command: zod.literal('testConnection'),
    }),
  ]),
});

export type FTPServerCommand = zod.infer<typeof FTPServerCommand>;
